module.exports = "<mat-card>We've sent you verification email. Please verify so you can login.</mat-card>\r\n"